import React from "react";
import LegalPage from "@/components/common/LegalPage";

export default function CookieNotice() {
  return (
    <LegalPage
      seo={{ title: "Cookie Notice | Premier Global Sourcing", description: "How Premier Global Sourcing uses cookies and similar technologies.", path: "/cookie-notice" }}
      eyebrow="Legal"
      title="Cookie Notice"
      updated="[ADD DATE]"
      breadcrumbs={[{ label: "Cookie Notice" }]}
      sections={[
        { heading: "What are cookies", body: "Cookies are small text files stored on your device that help websites function and understand how they are used." },
        { heading: "How we use cookies", body: ["Essential cookies that are required for the site to work correctly.", "Optional analytics cookies that help us understand usage and improve the site, only where enabled and consented to."] },
        { heading: "Managing cookies", body: "You can accept or decline optional cookies using the banner on this site, and you can control cookies through your browser settings at any time." },
        { heading: "Third-party services", body: "If we embed third-party services such as maps, those providers may set their own cookies subject to their policies." },
      ]}
    />
  );
}
